import { render, staticRenderFns } from "./priceLog.vue?vue&type=template&id=a06890a4"
import script from "./priceLog.vue?vue&type=script&lang=js"
export * from "./priceLog.vue?vue&type=script&lang=js"
import style0 from "./priceLog.vue?vue&type=style&index=0&id=a06890a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports